require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-press-release-civil-society-welcomes-the-introduct.json") })
        }
      }, "path---en-us-update-press-release-civil-society-welcomes-the-introduct");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-press-release-civil-society-welcomes-the-introduct!./.cache/json/en-us-update-press-release-civil-society-welcomes-the-introduct.json
// module id = 785
// module chunks = 231608221292675